module.exports = __webpack_public_path__ + "img/resize-full-screen.4d661dc5.svg";